<div [formGroup]="rulesFormGroup">
  <label for="{{controlName}}" class="check-toggle" id="lbl{{controlName}}">
    <input id="{{controlName}}" formControlName="{{controlName}}" type="checkbox" (change)="clickBooleanValue($event, rule)"
      [readonly]="!isEditAuthorized" class="nc-toggle-control">
    <div id="{{controlSliderWrapperName}}" class="check-toggle__slider-wrapper">
      <div class="check-toggle__slider"></div>
    </div>
  </label>
</div>
